// const base_url ="http://localhost:8095";
const base_url ="https://lmsjava.ujjawalsrijan.com";
// const base_url ="http://api.lms.UjjawalSrijan.com";
export default base_url;